var _defs, _style, _path, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftNavigationBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223 637",
    width: 223,
    height: 637,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lime") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 206,
    height: 637,
    id: "img1",
    href: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjA2IiBoZWlnaHQ9IjYzNyIgdmlld0JveD0iMCAwIDIwNiA2MzciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNTMuNjc1IDI4Ny40MTdDMTY3Ljk3OCAxNjUuMDQ2IDIyOS4wOSA4My45Mzk2IDE5NC45NCAtMy41Njk4MkgwVjY2Ny4zMzVDNzYuODM3NSA2NjcuMzM1IDEzMS4wNjEgNzQxLjMyNyAxNjYuNDgxIDYyNC42NDhDMTk2LjM2MyA1MjYuMjE2IDEzOS4zNzIgNDA5Ljc4NyAxNTMuNjc1IDI4Ny40MTdaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMTA3Xzg4MTgpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTA3Xzg4MTgiIHgxPSIxMDIuNDUiIHkxPSIxNTIuMjQiIHgyPSIxMDIuNDUiIHkyPSI2NTMuMTA2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMwODE2MkUiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMTQyOTRFIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #c4d82e } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m176.4 654.5c-37.5 93.9-189.2 17.1-189.2 17.1v-687.3c0 0 231.5-15.6 233.4 0 13.2 113.2-41.3 173.6-72.6 303.1-31.3 129.5 91 210.6 28.4 367.1z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "nav bg",
    href: "#img1",
    transform: "matrix(1,0,0,1,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftNavigationBg);
export default __webpack_public_path__ + "static/media/leftNavigationBg.971551c655d45bd049862ddb46ea90a0.svg";
export { ForwardRef as ReactComponent };